export const GDMSCONSTANT = {
    app_name: 'GDMS',
    app_type: 'GDMS-External'
}
